<script setup>
import {defineProps, onMounted, ref} from "vue";
import {useContactsStore} from "@/stores/contactsStore";
import {useICPStore} from "@/stores/icpStore";

const icpStore = useICPStore();
const ICP = icpStore.ICP;

// eslint-disable-next-line no-unused-vars
const props = defineProps({
  selected: String,
});

const contactsStore = useContactsStore();
const currTab = ref("call");

onMounted(() => {
  // Fetch online devices
  ICP.dispatch.query.queryUserListV1({
    "offset": "0",
    "limit": "100",
    "callback": function (data) {
      contactsStore.setNetworkContacts(data)
    }
  })
  // Fetch online trains every 10 seconds
  setInterval(() => {
    contactsStore.fetchTrainsList()
  }, 10000);
})


const headersTrains = [
  {title: "Train Set Id", key: "trainId", headerProps: {style: "font-weight: bold"}, sortable: false},
  {title: "ISDN", key: "isdn", headerProps: {style: "font-weight: bold"}, sortable: false},
  {title: "Operation Id", key: "runNumber", headerProps: {style: "font-weight: bold"}, sortable: false},
  //{title: "Driver Nr", key: "driverNumber", sortable: false, headerProps: {style: "font-weight: bold"}},
  {title: "Location", key: "location", sortable: false, headerProps: {style: "font-weight: bold"}},
];

const headersHandheld = [
  {title: "HandHeld", key: "radioId", headerProps: {style: "font-weight: bold"}, sortable: false},
  {title: "ISDN", key: "isdn", headerProps: {style: "font-weight: bold"}, sortable: false},
];

function colorRowItemTrains(item) {
  return {
    class: contactsStore.selectedTrains.some((s) => s.value.trainId === item.item.trainId) ? "selected" : "row",
  };
}

function colorRowItemHandheld(item) {
  return {
    class: contactsStore.selectedHandheld.some((s) => s.value === item.item) ? "selected" : "row",
  };
}

function handleRowSelection(event, {internalItem}, collection, setCollection) {
  const isCtrl = event.ctrlKey;
  const itemSelected = collection.some((s) => s.value === internalItem.value);

  if (!isCtrl) {
    // Clear all other selections if Ctrl is NOT pressed
    if (collection !== contactsStore.selectedTrains)
      contactsStore.selectedTrains = [];
    if (collection !== contactsStore.selectedHandheld)
      contactsStore.selectedHandheld = [];
    if (collection !== contactsStore.selectedPhoneContacts)
      contactsStore.selectedPhoneContacts = [];
  }

  if (itemSelected) {
    if (isCtrl) {
      setCollection(collection.filter((s) => s.value !== internalItem.value));
    } else {
      if (collection.length > 1) {
        setCollection([internalItem]);
      } else {
        setCollection([]);
      }
    }
  } else {
    if (isCtrl) {
      setCollection([...collection, internalItem]);
    } else {
      setCollection([internalItem]);
    }
  }
}


</script>

<template>
  <v-navigation-drawer
      v-if="selected !== 'ALARMS'"
      color="surface-light"
      location="right"
      name="right-drawer"
      permanent
      width="455"
  >
    <v-container class="flex-column pt-3 w-100 h-100 pr-0 pb-0" style="margin-right: 0px; padding-right: 0">

      <!-- Trains / Handheld Section -->
      <v-row class="w-100" style="height: 100%;">
        <v-card class="h-100 w-100 ml-1" style="border-radius:0">
          <v-tabs v-model="currTab" bg-color="grey" height="30px">
            <v-tab value="trains">Trains</v-tab>
            <v-tab v-if="selected !== 'ALARMS'" value="handheld">Handheld</v-tab>
            <!--            <v-tab value="phoneBook">Phone Book</v-tab>-->
          </v-tabs>

          <v-card-text class="pa-0" style="height: calc(100% - 30px); overflow-y: auto;">
            <v-tabs-window v-model="currTab">
              <v-tabs-window-item value="trains">
                <v-data-table
                    v-model="contactsStore.selectedTrains"
                    :headers="headersTrains"
                    :items="contactsStore.getOnlineTrains"
                    :items-per-page="-1"
                    :row-props="colorRowItemTrains"
                    clickable-rows
                    density="compact"
                    fixed-header
                    hide-default-footer
                    item-value="item"
                    return-object
                    @click:row="(event, { internalItem }) => handleRowSelection(event, { internalItem }, contactsStore.selectedTrains, val => contactsStore.selectedTrains = val)"
                />
              </v-tabs-window-item>

              <v-tabs-window-item value="handheld">
                <v-data-table
                    v-model="contactsStore.selectedHandheld"
                    :headers="headersHandheld"
                    :items="contactsStore.getOnlineHandHeld"
                    :items-per-page="-1"
                    :row-props="colorRowItemHandheld"
                    clickable-rows
                    density="compact"
                    fixed-header
                    hide-default-footer
                    item-value="item"
                    return-object
                    @click:row="(event, { internalItem }) => handleRowSelection(event, { internalItem }, contactsStore.selectedHandheld, val => contactsStore.selectedHandheld = val)"
                />
              </v-tabs-window-item>
            </v-tabs-window>
          </v-card-text>
        </v-card>
      </v-row>
    </v-container>
  </v-navigation-drawer>
</template>


<style scoped>
:deep(.row:hover) {
  background-color: #E0E0E0;
}

:deep(.selected) {
  background-color: #3f3f3f;
  color: white;
}

</style>
